<nav>
  <div class="login_top_container" style="cursor: pointer;">
    <div class="logo_list_container" routerLink="/dashboard">
      <img src="../../../assets/images/abharan_logo.jpg" />
    </div>

    <div class="mobile_menu_ham_container">
      <div class="menu_main" (mouseenter)="toggleActive(true)" (mouseleave)="toggleActive(false)"><span><img
            src="../../../assets/images/user_icon.svg" alt=""></span>
        <div class="profile-card menu" [class.active]="isActiveUrl">
          <div class="prodile_header"><img style="width: 30px;" src="../../../assets/images/profile.png" alt="">
            <span>{{branch}}</span>
            <div class="mobile_no" *ngIf="this.roleID !== 99"><i class="fa fa-phone" aria-hidden="true"></i> &nbsp;
              {{mobile}}</div>
          </div>
          <div class="profile-options" *ngIf="roleID !== 99">
            <div class="option" (click)="resetpass()">
              <div>
                <span><i class="fa-solid fa-lock"></i></span>&nbsp;&nbsp;Reset Password
              </div>

            </div>
          </div>
          <div class="profile-options">
            <div class="option" (click)="logout()">
              <div>
                <img src="../../../assets/images/logout.png" alt="image" /> Logout
              </div>
              <div>
                <i class="fa-solid fa-caret-right"></i>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="mobile_menu_ham" (click)="hamClick()" style="cursor: pointer;font-size: 18px;"><span
          *ngIf="!mobileMenuActive">Menu </span><span *ngIf="mobileMenuActive">Close </span><i
          class="fa-solid fa-bars"></i></div>
    </div>
  </div>

  <div class="nav_btm_container">
    <ul class="nav_list_container">
      <li [class.active]="currentRoute.includes('/dashboard')"><img src="../../../assets/images/Dashboard.svg" /><a
          routerLink="/dashboard">Dashboard</a></li>
      <li [class.active]="currentRoute.includes('/customer-list')"><img style="width: 23px;"
          src="../../../assets/images/user.png" /><a routerLink="/customer-list">Customer List</a></li>

      <li *ngIf="roleID===99" [class.active]="currentRoute.includes('/fact-feedback')"><img style="width: 25px;"
          src="../../../assets/images/fac-feedback.png" /><a routerLink="/fact-feedback">Facts and
          Feedback</a></li>
      <li *ngIf="roleID===99" [class.active]="currentRoute.includes('/branch')"><img style="width: 25px;"
          src="../../../assets/images/branch.png" /><a routerLink="/branch">Branches</a></li>
      <li *ngIf="roleID===99" [class.active]="currentRoute.includes('/offer')"><img style="width: 25px;"
          src="../../../assets/images/offer.png" /><a routerLink="/offer">Offers</a></li>
      <li class="settings-dropdown"
        [class.open]="currentRoute.startsWith('/gold-plan') || currentRoute.startsWith('/user-gold-plan-detail')"
        (click)="togglegoldDropdownOpen()">
        <img style="width: 20px;" src="../../../assets/images/offer.png" />
        <a href="javascript:void(0)" [class.dropdownlinkactive]="currentRoute.includes('/gold-plan')||currentRoute.includes('/user-gold-plan-detail')">Gold Plans</a>

        <ul class="dropdown-menu" [class.show]="goldDropdownOpen">
          <li [class.active]="currentRoute==='/gold-plan'">
            <!-- <img style="width: 25px;" src="../../../assets/images/scheme.png" /> -->
            <a routerLink="/gold-plan">Gold Plans List</a>
          </li>
          <li [class.active]="currentRoute==='/user-gold-plan-detail'">
            <!-- <img style="width: 25px;" src="../../../assets/images/feedback.png" /> -->
            <a routerLink="/user-gold-plan-detail">User Gold Plans Details</a>
          </li>
        </ul>
      </li>
      <li class="settings-dropdown" (click)="toggleSettingsDropdown()">
        <img style="width: 20px;" src="../../../assets/images/offer.png" />
        <a href="javascript:void(0)" [class.dropdownlinkactive]="currentRoute.includes('/posts')||currentRoute.includes('/add-video')||currentRoute.includes('/reels')">Media Section</a>

        <ul class="dropdown-menu" [class.show]="settingsDropdownOpen">
          <li *ngIf="roleID===99" [class.active]="currentRoute.includes('/posts')" routerLink="/posts">
            <a >Posts</a>
          </li>
          <li *ngIf="roleID===99" [class.active]="currentRoute.includes('/add-video')" routerLink="/add-video">
            <a >Video</a>
          </li>
          <li *ngIf="roleID===99" [class.active]="currentRoute.includes('/reels')" routerLink="/reels">
            <a >Reels</a>
          </li>
          <li *ngIf="roleID===99" [class.active]="currentRoute.includes('/scheduled-media-list')" routerLink="/scheduled-media-list">
            <a >Scheduled Media</a>
          </li>
        </ul>
      </li>

    </ul>
  </div>

</nav>



<div [ngClass]="{'mobile_menu' : true , 'active' : mobileMenuActive}">
  <div class="mobile_menu_wrapper">
    <ul class="nav_list_container">
      <li [class.active]="currentRoute.includes('/dashboard')"><img src="../../../assets/images/Dashboard.svg" /><a
          routerLink="/dashboard">Dashboard</a></li>
      <li [class.active]="currentRoute.includes('/gold-plan')"><img style="width: 25px;"
          src="../../../assets/images/scheme.png" /><a routerLink="/gold-plan">Gold Plans List</a></li>
      <li [class.active]="currentRoute.includes('/customer-list')"><img style="width: 25px;"
          src="../../../assets/images/feedback.png" /><a routerLink="/customer-list">Customer List</a>
      </li>
      <li [class.active]="currentRoute.includes('/user-gold-plan-detail')"><img style="width: 25px;"
          src="../../../assets/images/scheme.png" /><a routerLink="/user-gold-plan-detail">User Gold Plans
          Details</a>
      </li>
      <li *ngIf="roleID===99" [class.active]="currentRoute.includes('/fact-feedback')"><img style="width: 25px;"
          src="../../../assets/images/fac-feedback.png" /><a routerLink="/fact-feedback">Facts and
          Feedback</a></li>
      <li *ngIf="roleID===99" [class.active]="currentRoute.includes('/branch')"><img style="width: 25px;"
          src="../../../assets/images/branch.png" /><a routerLink="/branch">Branch</a></li>
      <li *ngIf="roleID===99" [class.active]="currentRoute.includes('/offer')"><img style="width: 25px;"
          src="../../../assets/images/offer.png" /><a routerLink="/offer">Offers</a></li>

    </ul>
  </div>
</div>


<!-- Logout Confirmation Modal -->
<div class="modal fade" id="logoutModal" tabindex="-1" aria-labelledby="logoutModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-body">
        <div class="modal_header_img">
          <img src="../../../assets/images/logout_mark.png" alt="">
        </div>
        <div class="modal_header_txt">Confirm Logout?</div>
        <div class="modal_bdy_des">Your current session will end,<br>and you’ll need to log in again. <br /> Do
          you want to continue?</div>
        <div class="modal_btn">
          <button class="cancel_btn" data-bs-dismiss="modal">Cancel</button>
          <button class="confrm_btn" (click)="confirmLogout()">Yes Logout</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade category_pop" id="myModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <form [formGroup]="adminresetForm">
        <div class="modal-header">
          <h5 class="appointment-modal-title" id="exampleModalLabel">
            Reset Password
          </h5>
          <div class="cancel_mark" data-bs-dismiss="modal">
            <img src="../../assets/images/x-square.svg" />
          </div>
        </div>
        <!-- <div class="modal-body">
                <input type="text" placeholder="Old Password" class="form-control" />
            </div> -->
        <div class="modal-body">
          <div class="password_title">{{branch}} <b>|</b> {{mobile}}</div>
          <input type="text" placeholder="New Password" class="form-control" formControlName="password" />
          <div *ngIf="(p['password'].touched || submitted) && p['password'].errors?.['required']"
            class="invalid-feedback">
            Password is Required
          </div>
          <div *ngIf="(p['password'].touched || submitted) && p['password'].errors?.['pattern']"
            class="invalid-feedback">
            Cannot Start Or End With WhiteSpaces
          </div>
        </div>
        <div class="modal-body">
          <input type="text" placeholder="Confirm Password" class="form-control" formControlName="confirm_password" />
          <div *ngIf="(p['confirm_password'].touched || submitted) && p['confirm_password'].errors?.['required']"
            class="invalid-feedback">
            Confrim Password is Required
          </div>
          <div *ngIf="(p['confirm_password'].touched || submitted) && p['confirm_password'].errors?.['pattern']"
            class="invalid-feedback">
            Cannot Start Or End With WhiteSpaces
          </div>
          <div
            *ngIf="(p['confirm_password'].touched || submitted) && (!p['confirm_password'].errors?.['required'])  && ( !p['confirm_password'].errors?.['pattern']) && adminresetForm.hasError('passwordMismatch')"
            class="invalid-feedback">
            Password and Confirm Password must match.
          </div>
        </div>
      </form>
      <div class="modal-footer">
        <button class="save_print" type="button" (click)="adminResetpassword()">Update Changes</button>
      </div>
    </div>
  </div>
</div>